<template>
    <v-container>
        <v-card style="border-radius: 8px;">
            <v-layout v-for="(rule,rulesindex) in crules" 
                                :key="rulesindex">
                <v-flex xs6>
                    <div  class="ml-5 ">Keywords</div>
                    <v-card flat class="mt-2 ml-4 blue-grey lighten-5" style="border-radius: 8px;">
                        <v-chip v-for="(keyword,keywordsindex) in rule.keywords" 
                                :key="keywordsindex" 
                                small 
                                close 
                                outline
                                @input="keywordDelete(rulesindex,keywordsindex)">
                            {{keyword}}
                        </v-chip>
                        <v-card-actions>
                        <v-btn @click="addkeyword($event,'keyword',rulesindex)" flat block color="primary">+ Add keyword</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex >
                <v-flex xs6>                    
                    <div  class="ml-4">Responses</div>
                    <v-card flat class="mt-2 mr-4 blue-grey lighten-5" style="border-radius: 8px;">
                        <v-chip 
                                v-for="(response,responseindex) in rule.responses" 
                                :key="responseindex"
                                small 
                                close 
                                outline
                                @input="responseDelete(rulesindex,responseindex)">
                            {{response.name}}
                        </v-chip>
                        <v-card-actions>
                        <v-btn @click="addresponse($event,'response',rulesindex)" flat block color="primary">+ Add response</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex>
                    <v-card flat class="ma-4 blue lighten-5" style="border-radius: 8px;">
                        <v-btn @click="addrule($event,'rule')" flat block color="primary">+ Add new Keywords response Mapping</v-btn>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-card> 
        <v-menu v-model="rulemenu"
                :close-on-click = "false"
                :position-x="x"
                :position-y="y"
                offset-x
                :close-on-content-click="false"
                :nudge-width="600">
            <v-card>
                <createrule v-if="cardtype == 'rule'"></createrule>
                <createkeyword v-if="cardtype == 'keyword'"></createkeyword>
                <createresponse v-if="cardtype == 'response'"></createresponse>
            </v-card>
        </v-menu>       
    </v-container>
</template>

<script>
import createrule from './Automation-createrule.vue'
import createkeyword from './Automation-createkeyword.vue'
import createresponse from './Automation-createresponse.vue'
export default {
    components:{
        createrule,
        createkeyword,
        createresponse
    },
    data(){
        return{
            cardtype:null,
            x:null,
            y:null
        }
    },
    methods:{
        addrule(event,type){
            event.preventDefault()
            this.x = event.clientX
            this.y = event.clientY
            this.cardtype = type
            let status = true
            this.$store.dispatch('arulemenuStatusChange',status)
        },
        addkeyword(event,type,index){
            event.preventDefault()
            this.x = event.clientX
            this.y = event.clientY
            this.cardtype = type
            let status = true
            this.$store.dispatch('aruleindexChange',index)
            this.$store.dispatch('arulemenuStatusChange',status)
        },
        addresponse(event,type,index){
            event.preventDefault()
            this.x = event.clientX
            this.y = event.clientY
            this.cardtype = type
            let status = true            
            console.log(index)
            this.$store.dispatch('aruleindexChange',index)
            this.$store.dispatch('arulemenuStatusChange',status)
        },
        responseDelete(ruleindex, responseindex){
            let index = ruleindex
            let rules = this.$store.state.rules
            let responses = rules[ruleindex].responses
            let keywords = rules[ruleindex].keywords
            responses.splice(responseindex,1)
            let rule = {"keywords":keywords,"responses":responses} 
            this.$store.dispatch('aupdaterule',{rule,index})

        },
        keywordDelete(ruleindex, keywordindex){
            let index = ruleindex
            let rules = this.$store.state.rules
            let responses = rules[ruleindex].responses
            let keywords = rules[ruleindex].keywords
            keywords.splice(keywordindex,1)
            let rule = {"keywords":keywords,"responses":responses} 
            this.$store.dispatch('aupdaterule',{rule,index})
            
        }        
    },
    computed:{
        crules(){
            return this.$store.state.rules            
        },
        rulemenu(){
            return this.$store.state.ruleMenuStatus
        }
    }    
}
</script>
